import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useTeam } from "../../context/TeamContext";
import Footer from "./Footer";
import AccessStatusPage from "../access/AccessStatusPage";
import "./LoginTeamGate.css";

export default function LoginTeamGate({
  showFooter = !(typeof window !== "undefined" && window.desktopAPI),
  requireTeam = true,
  loginMessage = "Please Login to enjoy this function",
  joinTeamMessage = "Please Join A Team to enjoy this function",
  loginButtonText = "Go to Login Page",
  joinTeamButtonText = "Go to Team Dashboard",
}) {
  const navigate = useNavigate();
  const { userData, loading: authLoading, error: authError, refreshAuth } = useAuth();
  const { teamId, loading: teamLoading, error: teamError, refreshTeam } = useTeam();

  const isLoading = authLoading || (requireTeam && Boolean(userData) && teamLoading);
  const error = authError || (requireTeam && userData && teamError);
  const isLoggedIn = !!userData;
  const hasTeam = !!teamId;

  let title = loginMessage;
  let buttonText = loginButtonText;
  let buttonPath = "/login";

  if (isLoggedIn && requireTeam && !hasTeam) {
    title = joinTeamMessage;
    buttonText = joinTeamButtonText;
    buttonPath = "/team-center/dashboard";
  }

  if (error) {
    return <AccessStatusPage error={error} onRetry={authError ? refreshAuth : refreshTeam} showFooter={showFooter} />;
  }

  if (isLoading) {
    return (
      <>
        <div className="LoginTeamGatePage">
          <div className="LoginTeamGateContent">
            <div className="LoginTeamGateCard">
              <h2 className="LoginTeamGateTitle">Loading...</h2>
            </div>
          </div>
        </div>
        {showFooter && <Footer />}
      </>
    );
  }

  return (
    <>
      <div className="LoginTeamGatePage">
        <div className="LoginTeamGateContent">
          <div className="LoginTeamGateCard">
            <h2 className="LoginTeamGateTitle">{title}</h2>

            <button
              type="button"
              className="LoginTeamGateButton"
              onClick={() => navigate(buttonPath)}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>

      {showFooter && <Footer />}
    </>
  );
}
